import apiService, { buildQueryString } from './api';
class UsuariosService {
    // Listar usuários
    async list(filters = {}) {
        const queryString = buildQueryString(filters);
        const response = await apiService.get(`/usuarios${queryString}`);
        return {
            usuarios: response.data || [],
            pagination: response.pagination || {
                page: 1,
                limit: 20,
                total: 0,
                totalPages: 0,
                hasNext: false,
                hasPrev: false
            }
        };
    }
    // Buscar usuário por ID
    async getById(id) {
        const response = await apiService.get(`/usuarios/${id}`);
        return response.data;
    }
    // Criar usuário
    async create(data) {
        const response = await apiService.post('/usuarios', data);
        return response.data;
    }
    // Atualizar usuário
    async update(id, data) {
        const response = await apiService.put(`/usuarios/${id}`, data);
        return response.data;
    }
    // Excluir usuário
    async delete(id) {
        await apiService.delete(`/usuarios/${id}`);
    }
    // Alternar status (ativo/inativo)
    async toggleStatus(id) {
        const response = await apiService.patch(`/usuarios/${id}/toggle-status`);
        return response.data;
    }
}
// Instância singleton
const usuariosService = new UsuariosService();
export default usuariosService;
// Utilitários
export const tiposUsuario = [
    { value: 'ADMIN', label: 'Administrador', color: 'red', icon: '👑' },
    { value: 'TECNICO', label: 'Técnico', color: 'blue', icon: '🔧' },
    { value: 'VENDEDOR', label: 'Vendedor', color: 'green', icon: '💼' }
];
export const getTipoUsuarioConfig = (tipo) => {
    return tiposUsuario.find(t => t.value === tipo) || tiposUsuario[0];
};
export const formatarTipoUsuario = (tipo) => {
    const config = getTipoUsuarioConfig(tipo);
    return config.label;
};
export const getTipoUsuarioColor = (tipo) => {
    const config = getTipoUsuarioConfig(tipo);
    return config.color;
};
export const getTipoUsuarioIcon = (tipo) => {
    const config = getTipoUsuarioConfig(tipo);
    return config.icon;
};
export const formatarDataLogin = (data) => {
    if (!data)
        return 'Nunca';
    const dataLogin = new Date(data);
    const agora = new Date();
    const diffMs = agora.getTime() - dataLogin.getTime();
    const diffDias = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDias === 0) {
        return 'Hoje';
    }
    else if (diffDias === 1) {
        return 'Ontem';
    }
    else if (diffDias < 30) {
        return `Há ${diffDias} dias`;
    }
    else {
        return dataLogin.toLocaleDateString('pt-PT');
    }
};
export const validarEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};
export const validarSenha = (senha) => {
    if (senha.length < 6) {
        return { valida: false, mensagem: 'Senha deve ter pelo menos 6 caracteres' };
    }
    if (!/(?=.*[a-z])/.test(senha)) {
        return { valida: false, mensagem: 'Senha deve conter pelo menos uma letra minúscula' };
    }
    if (!/(?=.*[A-Z])/.test(senha)) {
        return { valida: false, mensagem: 'Senha deve conter pelo menos uma letra maiúscula' };
    }
    if (!/(?=.*\d)/.test(senha)) {
        return { valida: false, mensagem: 'Senha deve conter pelo menos um número' };
    }
    return { valida: true };
};
export const gerarSenhaAleatoria = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%';
    let senha = '';
    // Função auxiliar para gerar índice seguro no browser
    const getSecureRandomIndex = (arrayLength) => {
        const array = new Uint32Array(1);
        crypto.getRandomValues(array);
        return array[0] % arrayLength;
    };
    // Garantir pelo menos um de cada tipo
    senha += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[getSecureRandomIndex(26)];
    senha += 'abcdefghijklmnopqrstuvwxyz'[getSecureRandomIndex(26)];
    senha += '0123456789'[getSecureRandomIndex(10)];
    senha += '!@#$%'[getSecureRandomIndex(5)];
    // Completar até 8 caracteres
    for (let i = 4; i < 8; i++) {
        senha += chars[getSecureRandomIndex(chars.length)];
    }
    // Embaralhar usando algoritmo Fisher-Yates com crypto
    const senhaArray = senha.split('');
    for (let i = senhaArray.length - 1; i > 0; i--) {
        const j = getSecureRandomIndex(i + 1);
        [senhaArray[i], senhaArray[j]] = [senhaArray[j], senhaArray[i]];
    }
    return senhaArray.join('');
};
